import { sort } from 'timsort'

type ListState = State & {
    items: any[]
    buffer: any[]
    realtime: boolean
}

export const empty = {
    start: { info: { span: { normalized: '' } } },
    items: [],
    span: { begin: 0, end: 0 }
}

type LithologyEvent = Event & {
    type: 'start'
    events: {
        info: {
            _span: 'string'
        }
    }
}

export default function lithologyReducer(state: ListState = empty, event: LithologyEvent): ListState {
    // TODO If the event contains an error, show it on the console

    if ((event?.baseline && event?.type != 'event') || event?.layer > 0) {
        return state
    }

    switch (event?.type) {
        case 'start':
            const { start, end } = (event.events.info._span || {}) as { start: number; end: number }

            return {
                ...state,
                realtime: false,
                span: { begin: start, end },
                start: event.events,
                items: [],
                buffer: []
            }
        case 'span':
            if (state.start.info?._span) {
                return state
            }

            return {
                ...state,
                span: event.events
            }
        case 'endHistory':
            return {
                ...state,
                items: [...state.buffer],
                realtime: true,
                buffer: []
            }
        case 'event':
            if (event.events.length == 0) {
                return state
            }
            const property = state.realtime ? 'items' : 'buffer'

            state[property] = state[property].concat(event.events)
            sort(state[property], (a: DataEvent, b: DataEvent) => a.timestamp - b.timestamp)

            return state
        default:
            return state
    }
}
